<template>
  <nav v-if="visiblePages.length" class="mt-2" :aria-label="label">
    <ul class="pagination pagination-sm mb-0">
      <li class="page-item" :class="{ disabled: !canPrev }">
        <button class="page-link" @click="$emit('first')" :disabled="!canPrev">First</button>
      </li>
      <li class="page-item" :class="{ disabled: !canPrev }">
        <button class="page-link" @click="$emit('prev')" :disabled="!canPrev">Prev</button>
      </li>
      <li v-for="pageNumber in visiblePages" :key="`${keyPrefix}-${pageNumber}`" class="page-item" :class="{ active: pageNumber === page }">
        <button class="page-link" @click="$emit('goto', pageNumber)" :disabled="pageNumber === page">{{ pageNumber }}</button>
      </li>
      <li class="page-item" :class="{ disabled: !canNext }">
        <button class="page-link" @click="$emit('next')" :disabled="!canNext">Next</button>
      </li>
      <li class="page-item" :class="{ disabled: !canNext }">
        <button class="page-link" @click="$emit('last')" :disabled="!canNext">Last</button>
      </li>
    </ul>
  </nav>
</template>

<script lang="ts" setup>
defineProps<{
  label: string
  keyPrefix: string
  page: number
  visiblePages: number[]
  canPrev: boolean
  canNext: boolean
}>()

defineEmits<{
  first: []
  prev: []
  goto: [pageNumber: number]
  next: []
  last: []
}>()
</script>
